export default __webpack_public_path__ + "static/media/browser.fdf49acf.png";